const handlePageLoadEvent = event => {
  document.querySelectorAll('input').forEach((el) => {
    el.dataset.lpignore = true
  })
}

window.onload = handlePageLoadEvent
addEventListener('turbolinks:load', handlePageLoadEvent)
